import Boolean from '@/modules/AdminTools/components/Form/Boolean';

const IsStackable = (props) => (
  <Boolean name="is_stackable" label="Is Stackable" {...props} />
);

export default IsStackable;
